<div class="title-divider-print-buttons mt-md-2">
  <h1 translate>forbidden.title</h1>
</div>

<p class="lead">
  <span translate>forbidden.text</span><br/>
  <span translate>security.adminHint</span>
</p>

<span translate>security.actionUrl</span>
<ul>
  <li>{{securityData.actionUrl}}</li>
</ul>
